// Owner/Builder Portal — API helpers (Prompt 6).
import { api } from "./api";

export async function getOwnerDashboard(userId) {
  const { data } = await api.get("/owner-portal/dashboard", {
    params: { user_id: userId },
  });
  return data;
}

export async function toggleSavedDesign(userId, designId) {
  const { data } = await api.post("/owner-portal/saved-designs/toggle", {
    actor_user_id: userId,
    design_id: designId,
  });
  return data;
}

export async function listSavedDesigns(userId) {
  const { data } = await api.get("/owner-portal/saved-designs", {
    params: { user_id: userId },
  });
  return data;
}

export async function requestConsultation(userId, payload) {
  const { data } = await api.post("/owner-portal/consultations", {
    actor_user_id: userId,
    ...payload,
  });
  return data;
}

export async function getOwnerConsultation(consultId, userId) {
  const { data } = await api.get(
    `/owner-portal/consultations/${encodeURIComponent(consultId)}`,
    { params: { user_id: userId } },
  );
  return data;
}

export async function postOwnerMessage(consultId, userId, body) {
  const { data } = await api.post(
    `/owner-portal/consultations/${encodeURIComponent(consultId)}/messages`,
    { actor_user_id: userId, body },
  );
  return data;
}

export async function sendOwnerProjectMessage(projectId, userId, body) {
  const { data } = await api.post(
    `/owner-portal/projects/${encodeURIComponent(projectId)}/messages`,
    { actor_user_id: userId, body },
  );
  return data;
}

export async function requestIteration(consultId, userId, note, variant) {
  const { data } = await api.post(
    `/owner-portal/consultations/${encodeURIComponent(consultId)}/iteration`,
    { actor_user_id: userId, note, variant: variant || "" },
  );
  return data;
}

export async function getOwnerMessages(userId) {
  const { data } = await api.get("/owner-portal/messages", {
    params: { user_id: userId },
  });
  return data;
}

export async function listOwnerProjects(userId) {
  const { data } = await api.get("/owner-portal/projects", {
    params: { user_id: userId },
  });
  return data;
}

export async function getOwnerProject(projectId, userId) {
  const { data } = await api.get(
    `/owner-portal/projects/${encodeURIComponent(projectId)}`,
    { params: { user_id: userId } },
  );
  return data;
}

export async function purchasePlans(projectId, userId, payment, signature) {
  const { data } = await api.post(
    `/owner-portal/projects/${encodeURIComponent(projectId)}/purchase-plans`,
    { actor_user_id: userId, payment, signature },
  );
  return data;
}

export async function triggerActivation(projectId, userId, action) {
  const { data } = await api.post(
    `/owner-portal/projects/${encodeURIComponent(
      projectId,
    )}/activation/${encodeURIComponent(action)}`,
    { actor_user_id: userId },
  );
  return data;
}

export async function generateDocument(projectId, userId, docType) {
  const { data } = await api.post(
    `/owner-portal/projects/${encodeURIComponent(projectId)}/documents`,
    { actor_user_id: userId, doc_type: docType },
  );
  return data;
}

export function packetPdfUrl(projectId, userId) {
  const base = api.defaults.baseURL.replace(/\/+$/, "");
  return `${base}/owner-portal/projects/${encodeURIComponent(
    projectId,
  )}/packet/pdf?user_id=${encodeURIComponent(userId)}`;
}

export async function downloadProjectPacket(projectId, userId, filename) {
  const url = packetPdfUrl(projectId, userId);
  const res = await fetch(url, { credentials: "omit" });
  if (!res.ok) throw new Error(`Download failed (${res.status})`);
  const blob = await res.blob();
  const objectUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = objectUrl;
  a.download = filename || `project-packet-${projectId}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
}

export function documentPdfUrl(documentId, userId) {
  const base = api.defaults.baseURL.replace(/\/+$/, "");
  return `${base}/owner-portal/documents/${encodeURIComponent(
    documentId,
  )}/pdf?user_id=${encodeURIComponent(userId)}`;
}

export async function downloadDocumentPdf(documentId, userId, filename) {
  const url = documentPdfUrl(documentId, userId);
  const res = await fetch(url, { credentials: "omit" });
  if (!res.ok) throw new Error(`Download failed (${res.status})`);
  const blob = await res.blob();
  const objectUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = objectUrl;
  a.download = filename || `document-${documentId}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Release the blob a tick later so the click() has time to read it.
  setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
}

